import {
  initialState,
  Actions,
  State,
  GET_WELCOME_CONTENT_SECTION,
  GET_WELCOME_CONTENT_SECTION_SUCCESS,
  GET_WELCOME_CONTENT_SECTION_ERROR,
  RESET_GET_WELCOME_CONTENT_SECTION,
  UPDATE_CURRENT_WELCOME_SECTION,
} from "../../types/welcome-content/get-welcome-content-section";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case GET_WELCOME_CONTENT_SECTION:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case GET_WELCOME_CONTENT_SECTION_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case GET_WELCOME_CONTENT_SECTION_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      };
    case UPDATE_CURRENT_WELCOME_SECTION:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case RESET_GET_WELCOME_CONTENT_SECTION:
      return { ...initialState };
    default:
      return state;
  }
};

export default reducers;
